import React from 'react'

const RejectedIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="27.994" viewBox="0 0 28 27.994">
            <g id="Group_10693" data-name="Group 10693" transform="translate(11688.209 22659.533)">
                <rect id="Rectangle_8678" data-name="Rectangle 8678" width="28" height="27.995" rx="13.998" transform="translate(-11688.209 -22659.533)" fill="#f0d9db" />
                <line id="Line_1537" data-name="Line 1537" y2="12.957" transform="translate(-11669.629 -22650.117) rotate(45)" fill="none" stroke="#d3221e" strokeLinecap="round" strokeWidth="2.5" />
                <line id="Line_1538" data-name="Line 1538" y2="12.957" transform="translate(-11669.627 -22640.957) rotate(135)" fill="none" stroke="#d3221e" strokeLinecap="round" strokeWidth="2.5" />
            </g>
        </svg>
    )
}

export default RejectedIcon